import { FormControl, IconButton, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select } from '@mui/material'
import { memo } from 'react'
import { KEY_LABEL_SEARCH_COMPONENT_TYPE, MODULE_PREVIEW_ROUTER_FORM } from 'config/const/locale'
import { useTranslation } from 'react-i18next'

function SearchComponent({
    columns,
    Kword,
    saveKeyword,
    KType,
    ChangeKType
}) {

    const { t } = useTranslation(MODULE_PREVIEW_ROUTER_FORM)

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                width: 'fit-content',
                minWidth: 280,
                textAlign: 'left'
            }}
        >
            {/* type select */}
            <FormControl
                size='small'
                variant='outlined'
                sx={{
                    width: 'fit-content'
                }}
            >
                <InputLabel id='hearder-search-select'>{t(KEY_LABEL_SEARCH_COMPONENT_TYPE)}</InputLabel>
                <Select
                    labelId="hearder-search-select"
                    label={t(KEY_LABEL_SEARCH_COMPONENT_TYPE)}
                    value={KType}
                    onChange={(event, child) => ChangeKType(child?.props?.value)}
                >
                    {
                        columns?.map(
                            i => <MenuItem key={i?.id} value={i?.id}>{i?.name}</MenuItem>
                        )
                    }
                </Select>
            </FormControl>

            {/* search input */}
            <FormControl
                size='small'
                variant='outlined'
                sx={{
                    flex: 5,
                }}
            >
                {/* <InputLabel htmlFor="header-search-ipt" style={{ opacity: .5 }}>{KType}</InputLabel> */}
                <OutlinedInput
                    id='header-search-ipt'
                    variant="outlined"
                    size='small'
                    // label={KType}
                    value={Kword}
                    endAdornment={
                        <InputAdornment position='end'>
                            <IconButton
                                onClick={() => saveKeyword('')}
                            >
                                X
                            </IconButton>
                        </InputAdornment>
                    }

                    onChange={(event) => saveKeyword(event.target.value)}
                />
            </FormControl>
        </div>
    )
}

/**
 * search component for CMSTable
 * @Todo i18n
 * @param {Array[Object]} columns table data
 * @param {String} Kword keyword to search
 * @param {Function} saveKeyword keyword setter
 * @param {String} KType the type of keyword to search
 * @param {Function} ChangeKType type setter
 */
export default memo(SearchComponent)